var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 11.25,
    stroke: "#B3B3B3",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12408 14.5509C6.28947 14.7055 6.55823 14.7055 6.72363 14.5509L11.9955 9.61369L17.2777 14.5509C17.4431 14.7055 17.7119 14.7055 17.8772 14.5509C18.0426 14.3963 18.0426 14.1451 17.8772 13.9905L12.3056 8.78277C12.2229 8.70548 12.1195 8.66683 12.0058 8.66683C11.9025 8.66683 11.7888 8.70548 11.7061 8.78277L6.13442 13.9905C5.95869 14.1451 5.95869 14.3963 6.12408 14.5509Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95124 14.7944C6.65773 15.0687 6.18997 15.0687 5.89646 14.7944C5.58969 14.5077 5.58949 14.0302 5.90997 13.744L11.4784 8.53925C11.629 8.39849 11.8268 8.3335 12.0058 8.3335C12.1994 8.3335 12.3854 8.40113 12.5332 8.53925L18.1049 13.747C18.4112 14.0333 18.4112 14.5081 18.1049 14.7944C17.8113 15.0687 17.3436 15.0687 17.0501 14.7944L11.9957 10.0702L6.95124 14.7944ZM11.9955 9.61369L17.2777 14.5509C17.4431 14.7055 17.7119 14.7055 17.8772 14.5509C18.0426 14.3963 18.0426 14.1451 17.8772 13.9905L12.3056 8.78277C12.2229 8.70548 12.1195 8.66683 12.0058 8.66683C11.9025 8.66683 11.7888 8.70548 11.7061 8.78277L6.13442 13.9905C5.95869 14.1451 5.95869 14.3963 6.12408 14.5509C6.28947 14.7055 6.55823 14.7055 6.72363 14.5509L11.9955 9.61369Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveButton);
export default __webpack_public_path__ + "static/media/move-button.9ff5aed139c25d1765e8bb1214f410a8.svg";
export { ForwardRef as ReactComponent };